import { render, staticRenderFns } from "./ReportContent.vue?vue&type=template&id=472f5306&scoped=true"
import script from "./ReportContent.vue?vue&type=script&lang=js"
export * from "./ReportContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472f5306",
  null
  
)

export default component.exports